import Enums from 'utils/EnumsManager';

const { REPORT } = Enums.REDUX_ACTION_TYPE_PREFIX;
export const SET_ACTIVE_FOLDER = `${REPORT}_SET_ACTIVE_FOLDER`;
export const SET_EDITING_FOLDER = `${REPORT}_SET_EDITING_FOLDER`;
export const RESET_EDITING_FOLDER = `${REPORT}_RESET_EDITING_FOLDER`;
export const COMMIT_FOLDER_NAME = `${REPORT}_COMMIT_FOLDER_NAME`;
export const DELETE_FOLDER = `${REPORT}_DELETE_FOLDER`;
export const ADD_FOLDER = `${REPORT}_ADD_FOLDER`;
export const SYNC_FOLDER = `${REPORT}_SYNC_FOLDER`;
export const DELETE_LOCAL_FOLDER = `${REPORT}_DELETE_LOCAL_FOLDER`;
export const SET_ACTIVE_TAB = `${REPORT}_SET_ACTIVE_TAB`;



// WEBPACK FOOTER //
// ./src/views/ReportListSider/flow/actionTypes.js